export enum UserDeviceType {
  Android = "android",
  Mac = "mac",
  Web = "web",
  iOS = "ios",
  iOSMac = "iosmac",
}
